
document.addEventListener('DOMContentLoaded', () => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('pointermove', e => {
    document.documentElement.style.setProperty('--mx', e.clientX + 'px');
    document.documentElement.style.setProperty('--my', e.clientY + 'px');
  });
  let lenis = null;
  if (!reduced && window.Lenis) {
    lenis = new Lenis({duration:1.12,easing:t=>Math.min(1,1.001-Math.pow(2,-10*t)),smoothWheel:true,wheelMultiplier:.9,touchMultiplier:1.1});
    function raf(time){lenis.raf(time);requestAnimationFrame(raf)}
    requestAnimationFrame(raf);
  }
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      if (lenis) lenis.scrollTo(target, { offset:-90, duration:1.05 });
      else target.scrollIntoView({ behavior:'smooth', block:'start' });
    });
  });
  if (!window.gsap || !window.ScrollTrigger || reduced) {
    document.querySelectorAll('[data-animate]').forEach(el => {el.style.opacity=1;el.style.transform='none';el.style.clipPath='none'});
    return;
  }
  gsap.registerPlugin(ScrollTrigger);
  if (lenis) {lenis.on('scroll', ScrollTrigger.update);gsap.ticker.add(time => lenis.raf(time * 1000));gsap.ticker.lagSmoothing(0)}
  const ease = 'power3.out';
  gsap.fromTo('.hero .eyebrow',{opacity:0,y:22},{opacity:1,y:0,duration:.7,ease,delay:.05});
  gsap.fromTo('.hero h1',{opacity:0,y:34},{opacity:1,y:0,duration:.92,ease,delay:.14});
  gsap.fromTo('.hero-lead',{opacity:0,y:26},{opacity:1,y:0,duration:.82,ease,delay:.26});
  gsap.fromTo('.hero-actions',{opacity:0,y:22},{opacity:1,y:0,duration:.78,ease,delay:.38});
  gsap.fromTo('.hero-proof',{opacity:0,y:22},{opacity:1,y:0,duration:.78,ease,delay:.50});
  gsap.fromTo('.gate-visual',{opacity:0,scale:.96,y:38},{opacity:1,scale:1,y:0,duration:1.05,ease,delay:.20});
  gsap.fromTo('.gate-visual img:not(.gate-ghost)',{opacity:0,y:30,scale:.94},{opacity:1,y:0,scale:1,duration:1.05,ease,delay:.38});
  gsap.fromTo('.status-pill',{opacity:0,y:18,scale:.94},{opacity:1,y:0,scale:1,stagger:.12,duration:.72,ease,delay:.74});
  document.querySelectorAll('[data-animate]').forEach(el => {
    const type = el.dataset.animate;
    const delay = Number(el.dataset.delay || 0);
    const from = {opacity:0,duration:.9,ease,delay};
    if(type==='left')from.x=-42; else if(type==='right')from.x=42; else if(type==='scale')from.scale=.94; else if(type==='clip')from.clipPath='inset(0 0 100% 0 round 26px)'; else from.y=34;
    gsap.fromTo(el, from, {opacity:1,x:0,y:0,scale:1,clipPath:'inset(0 0 0% 0 round 26px)',duration:.9,ease,delay,scrollTrigger:{trigger:el,start:'top 84%',toggleActions:'play none none reverse'}});
  });
  gsap.to('.gate-visual img:not(.gate-ghost)', {yPercent:-7,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
  gsap.utils.toArray('.how-panel img, .product-shot img, .gallery-main img').forEach(img => {
    gsap.to(img, {yPercent:-6,ease:'none',scrollTrigger:{trigger:img.closest('section'),start:'top bottom',end:'bottom top',scrub:true}});
  });
  ScrollTrigger.refresh();
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-carousel]').forEach(carousel => {
    const slides = Array.from(carousel.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(carousel.querySelectorAll('[data-gallery-thumb]'));
    const prev = carousel.querySelector('[data-gallery-prev]');
    const next = carousel.querySelector('[data-gallery-next]');
    let active = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));

    const show = index => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === active));
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    if (prev) prev.addEventListener('click', () => show(active - 1));
    if (next) next.addEventListener('click', () => show(active + 1));
    show(active);
  });

  document.querySelectorAll('[data-inline-zoom]').forEach(frame => {
    const img = frame.querySelector('img');
    if (!img) return;
    const move = event => {
      const rect = frame.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      frame.classList.add('is-zoomed');
    };
    frame.addEventListener('pointermove', move);
    frame.addEventListener('pointerenter', move);
    frame.addEventListener('pointerleave', () => frame.classList.remove('is-zoomed'));
    frame.addEventListener('click', event => {
      if (event.pointerType === 'mouse') return;
      frame.classList.toggle('is-zoomed');
    });
  });

  document.querySelectorAll('.mobile-menu-button').forEach(button => {
    const nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  });
});

/* V2 banner parallax */
document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.fromTo('.banner-card', {opacity:0, y:36, scale:.97}, {opacity:1, y:0, scale:1, duration:1.05, ease:'power3.out', delay:.18});
  gsap.fromTo('.banner-meter, .banner-price', {opacity:0, y:18, scale:.95}, {opacity:1, y:0, scale:1, duration:.75, stagger:.12, ease:'power3.out', delay:.76});
  gsap.to('.banner-card img', {scale:1.08, yPercent:-4, ease:'none', scrollTrigger:{trigger:'.hero-conversion', start:'top top', end:'bottom top', scrub:true}});
});
